(() => {
  const selector = 'img[data-al-deferred-image]';
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          activateImage(entry.target);
        });
      }, { rootMargin: '300px 0px', threshold: 0 })
    : null;

  function activateImage(image) {
    if (image.dataset.alDeferredState !== 'pending') return;
    image.dataset.alDeferredState = 'loading';
    image.loading = 'eager';
    const markLoaded = () => {
      if (image.complete && image.naturalWidth > 1) image.dataset.alDeferredState = 'loaded';
    };
    image.addEventListener('load', markLoaded);
    image.addEventListener('error', () => {
      image.dataset.alDeferredState = 'error';
    }, { once: true });

    image.closest('picture')?.querySelectorAll('source[data-srcset]').forEach((source) => {
      source.srcset = source.dataset.srcset;
      source.removeAttribute('data-srcset');
    });

    const src = image.dataset.src;
    const srcset = image.dataset.srcset;
    image.removeAttribute('srcset');
    if (src) {
      image.src = src;
      image.removeAttribute('data-src');
    }
    if (srcset) {
      image.srcset = srcset;
      image.removeAttribute('data-srcset');
    }
    markLoaded();
    queueMicrotask(markLoaded);
    if (typeof image.decode === 'function') {
      image.decode().then(markLoaded).catch(() => {});
    }
  }

  function observeImages(root = document) {
    const images = root.matches?.(selector) ? [root] : root.querySelectorAll(selector);
    images.forEach((image) => {
      if (image.dataset.alDeferredState !== 'pending') return;
      if (observer) observer.observe(image);
      else activateImage(image);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeImages(), { once: true });
  } else {
    observeImages();
  }
  document.addEventListener('shopify:section:load', (event) => observeImages(event.target));

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element && (node.matches(selector) || node.querySelector(selector))) {
          observeImages(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
